import $app from 'app/stores/$app';
import Collection from 'core/model/Collection';
import BGPAnnouncementModel from './BGPAnnouncementModel';

class BGPAnnouncementCollection extends Collection {
  get url() {
    return '/api/ui/mitigations/announcements';
  }

  get defaultSortState() {
    return {
      field: 'deviceSessionStatus',
      direction: 'asc'
    };
  }

  get filterFieldWhitelist() {
    return new Set(['typeLabel', 'mitigationIds', 'deviceName', 'matchEntriesString', 'actionEntriesString']);
  }

  get model() {
    return BGPAnnouncementModel;
  }

  get uniqueMitigationIds() {
    const allMitigationIds = this.unfiltered.flatMap((model) => model.mitigationIds);
    return [...new Set(allMitigationIds)];
  }

  async fetch(options = {}) {
    if ($app.isSubtenant) {
      return Promise.resolve();
    }

    return super.fetch(options);
  }

  deserialize(data) {
    const { updateDetails: announcementsArray = [] } = data || {};

    return super.deserialize(announcementsArray);
  }
}

export default BGPAnnouncementCollection;
